import { COMPARE_CATEGORY_BCC_KEY, type ComparePage, type ShowedCategories } from '@cc-shopping/contracts/compare/schema/types';
import type { ArpiType } from '@cc-shopping/sequencing/types';
import { forceDesktopOrMobile } from '@cc-shopping/sequencing/utils';
import { getClientDeviceType } from '@cc-shopping/utils/deviceType/client';
import { useMemo } from 'react';
import { getSortedRows } from 'src/features/summary-table/utils';
import { categorySlugMapper } from '../utils';
export function useCompareDataOrdering(arpiOrdering: ArpiType | undefined, compareData: ComparePage) {
  return useMemo(() => {
    const cloneCompareData = {
      ...compareData
    };
    Object.entries(compareData.offersByCategory).forEach(([category, {
      offers,
      ...rest
    }]) => {
      const typedCategory = category as ShowedCategories;
      let orderedOffers = offers;
      if (arpiOrdering && typedCategory !== COMPARE_CATEGORY_BCC_KEY) {
        const order = (arpiOrdering as ArpiType)[categorySlugMapper[typedCategory]]?.[forceDesktopOrMobile(getClientDeviceType())];
        orderedOffers = getSortedRows(orderedOffers, order);
      }
      (cloneCompareData as ComparePage).offersByCategory[typedCategory] = {
        offers: orderedOffers,
        ...rest
      };
    });
    return cloneCompareData;
  }, [compareData]);
}